import ApiCaller from './ApiCaller';
import IApiCaller from './IApiCaller';
export function createApiCaller(): IApiCaller {
    return new ApiCaller();
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/api/ApiFactory.ts